import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { useTags } from '@/hooks/use-settings'

const FALLBACK = '#64748b'

/** Màu của nhãn theo danh mục Cài đặt → Nhãn (nhãn lạ không có trong danh mục dùng màu xám). */
export function useTagColor() {
  const { data } = useTags()
  return (name: string) => data?.find((t) => t.name.toLowerCase() === name.toLowerCase())?.color ?? FALLBACK
}

export function TagChip({ name, className, onRemove }: { name: string; className?: string; onRemove?: () => void }) {
  const { t } = useTranslation('sharedMisc')
  const color = useTagColor()(name)
  return (
    <span
      className={cn('inline-flex max-w-[11rem] items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium', className)}
      style={{ backgroundColor: `${color}20`, color }}
      title={name}
    >
      <span className="truncate">{name}</span>
      {onRemove && (
        <button type="button" aria-label={t('tagChip.removeTag', { name })} onClick={onRemove} className="rounded px-0.5 hover:bg-background/50">
          ×
        </button>
      )}
    </span>
  )
}
